/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, InputGroup, Modal, Spinner } from "react-bootstrap";

export default function ConfirmationModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      title=""
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.title}
        </Modal.Title>
      </Modal.Header>
      {props.custombody}
      {!props.custombody && props.body && (
        <>
          <Modal.Body>{props.custombody || props.body}</Modal.Body>
          <Modal.Footer>
            {!props.showspinner ? (
              props.customfooter ? (
                props.customfooter
              ) : (
                <div style={{ width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                  <Button
                    style={{ marginRight: '10px' }}
                    onClick={(e) => props.onHide(e, false)}
                    variant="outline-secondary"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={(e) => props.onHide(e, true)}
                    variant="outline-primary"
                  >
                    {props.confirmtext}
                  </Button>
                </div>
              )
            ) : (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            )}
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
}
